export const ROLES = {
  OWNER: "verified_admin",
  ADMIN: "admin",
  MANAGER: "manager",
  CASHIER: "cashier",
  TEMP: "temp",
};

export const ROLES_MAPPER: string[] = [
  "VERIFIED_ADMIN",
  "ADMIN",
  "MANAGER",
  "TEMP",
  "CASHIER",
];
